import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { generateColorRamp } from '@antv/l7-utils';
export function updateTexture(config, layers, rendererService) {
  var createTexture2D = rendererService.createTexture2D;
  var imageData = generateColorRamp(config);
  var texture = createTexture2D({
    data: imageData.data,
    width: imageData.width,
    height: imageData.height,
    flipY: false
  });
  layers.map(function (layer) {
    layer.updateLayerConfig({
      colorTexture: texture
    });
  });
  return texture;
}
export function updateLayersConfig(layers, key, value) {
  layers.map(function (layer) {
    if (key === 'mask') {
      // Tip: 栅格瓦片生效、设置全局的 mask、瓦片被全局的 mask 影响
      layer.style({
        mask: value
      });
    } else {
      layer.updateLayerConfig(_defineProperty({}, key, value));
    }
  });
}
export function setStyleAttributeField(layer, parent, style, value) {
  if (Array.isArray(value)) {
    // @ts-ignore
    layer[style].apply(layer, _toConsumableArray(value));
    return;
  }

  if (typeof value === 'string') {
    layer[style](value);
    return;
  }

  var defaultValue = getDefaultStyleAttributeField(layer, parent.type, style);

  if (!value) {
    layer[style](defaultValue);
    return layer;
  }

  var params = parseScaleValue(value, style);

  if (params.length === 0) {
    layer[style](defaultValue);
  } else {
    // @ts-ignore
    layer[style].apply(layer, _toConsumableArray(params));
  }
}
export function getDefaultStyleAttributeField(layer, type, style) {
  switch (style) {
    case 'size':
      return 1;

    case 'color':
      return '#fff';

    case 'shape':
      return getLayerShape(type, layer);

    default:
      return '';
  }
}
export function getLayerShape(layerType, layer) {
  var _layerShape$scale;

  var layerShape = layer.getAttribute('shape');

  if (layerShape && (_layerShape$scale = layerShape.scale) !== null && _layerShape$scale !== void 0 && _layerShape$scale.field) {
    var _layerShape$scale2;

    if (((_layerShape$scale2 = layerShape.scale) === null || _layerShape$scale2 === void 0 ? void 0 : _layerShape$scale2.values) === 'text') {
      return [layerShape.scale.field, layerShape.scale.values];
    }

    return layerShape.scale.field;
  }

  switch (layerType) {
    case 'PolygonLayer':
      return 'fill';

    case 'LineLayer':
      return 'tileline';

    case 'PointLayer':
      return 'circle';

    case 'RasterLayer':
      return 'image';

    default:
      return '';
  }
}
export function parseScaleValue(value, type) {
  if (type === 'shape') {
    if (typeof value === 'string') {
      return [value];
    } else if (value !== null && value !== void 0 && value.field) {
      return [value === null || value === void 0 ? void 0 : value.field];
    } else {
      return [];
    }
  }

  var _ref = value,
      field = _ref.field,
      values = _ref.values,
      callback = _ref.callback;

  if (field && values && Array.isArray(values)) {
    return [field, values];
  } else if (field && callback) {
    return [field, callback];
  } else if (field) {
    return [field];
  }

  return [];
}
export function setScale(layer, parent) {
  var scaleOptions = parent.tileLayer.scaleField;
  var scaleKeys = Object.keys(scaleOptions);
  scaleKeys.map(function (key) {
    layer.scale(key, scaleOptions[key]);
  });
}